const cartCheckboxEls = document.querySelectorAll('.js-cart-checkbox');

if (cartCheckboxEls) {
  document.addEventListener('change', (event) => {
    if (!event.target.matches('.js-cart-checkbox')) { return; }
    event.target.parentElement.parentElement.classList.toggle('.js-active');
    const target = document.querySelector(event.target.dataset.check);
    target.classList.toggle('k-d-none');
  }, false);
}
